

import { IConnection, ITag } from "../../interfaces/models/connection"
import { ActionType, TConnectionsFilterState } from "../../interfaces/store/connectionStore"
import { IWorkspaceCustomField } from "../../interfaces/models/workspace"
import { IConnectionsQueryParams } from "../../services/apis/connections/useConnectionsRequest"
import { useConnectionsStore } from "./useConnectionsStore"


export const useConnectionsActions = () => {
    const { dispatch } = useConnectionsStore()

    const setConnectionsFilter = (payload: TConnectionsFilterState) => {
        return dispatch({
            type: ActionType.SET_CONNECTIONS_FILTER,
            payload
        })
    }

    const setCampaignConnectionsFilter = (payload: TConnectionsFilterState) => {
        return dispatch({
            type: ActionType.SET_CAMPAIGN_CONNECTIONS_FILTER,
            payload
        })
    }

    const replaceCampaignConnectionsFilter = (payload: TConnectionsFilterState) => {
        return dispatch({
            type: ActionType.REPLACE_CAMPAIGN_CONNECTIONS_FILTER,
            payload
        })
    }

    const setConnectionsFilterScope = (payload: 'contacts' | 'campaign') => {
        return dispatch({
            type: ActionType.SET_CONNECTIONS_FILTER_SCOPE,
            payload
        })
    }

    const setConnections = (payload: IConnection[]) => {
        return dispatch({
            type: ActionType.SET_CONNECTIONS,
            payload
        })
    }

    /** Safely patches a single connection by _id — race-condition-safe (runs in reducer). */
    const patchConnection = (id: string, patch: Partial<IConnection>) => {
        return dispatch({
            type: ActionType.PATCH_CONNECTION,
            payload: { id, patch }
        })
    }

    const resetConnectionsStore = () => {
        return dispatch({
            type: ActionType.RESET_STORE
        })
    }

    const setMultipleConditionsFilters = (payload: IConnectionsQueryParams) => {
        return dispatch({
            type: ActionType.SET_MULTIPLE_CONDITIONS_FILTERS,
            payload
        })
    }

    const setConnectionFilterOptions = (payload: any) => {
        return dispatch({
            type: ActionType.SET_CONNECTIONS_FILTER_OPTIONS,
            payload
        })
    }

    const setConnectionsParameters = (payload: any) => {
        return dispatch({
            type: ActionType.SET_CONNECTIONS_PARAMETERS,
            payload
        })
    }

    const resetConnectionsPagination = () => {
        return dispatch({
            type: ActionType.RESET_CONNECTIONS_PAGINATION
        })
    }

    const setScheduledRemovalParameters = (payload: any) => {
        return dispatch({
            type: ActionType.SET_SCHEDULED_REMOVAL_PARAMETERS,
            payload
        })
    }

    const setSelectedConnectionsIds = (payload: string[]) => {
        return dispatch({
            type: ActionType.SET_SELECTED_CONNECTIONS_IDS,
            payload
        })
    }

    const setCustomFieldDefinitions = (payload: IWorkspaceCustomField[]) => {
        return dispatch({
            type: ActionType.SET_CUSTOM_FIELD_DEFINITIONS,
            payload
        })
    }

    const setEnrichingConnections = (payload: Array<{ connectionId: string; type: string }>) => {
        return dispatch({
            type: ActionType.SET_ENRICHING_CONNECTIONS,
            payload
        })
    }

    return {
        setConnectionsFilter,
        setCampaignConnectionsFilter,
        replaceCampaignConnectionsFilter,
        setConnectionsFilterScope,
        resetConnectionsStore,
        setConnections,
        patchConnection,
        setMultipleConditionsFilters,
        setConnectionFilterOptions,
        setConnectionsParameters,
        resetConnectionsPagination,
        setScheduledRemovalParameters,
        setSelectedConnectionsIds,
        setCustomFieldDefinitions,
        setEnrichingConnections
    }
}


